export default "__VITE_ASSET__13c64114__"